import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const clientApi = createApi({
  reducerPath: "client",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getClients: build.query({
      query: searchCriteria => ({
        url: '/api/Client/Search',
        method: 'POST',
        body: searchCriteria
      }),
      providesTags: ['Clients']
    }),
    getAllClientsWithoutDetails: build.query({
      query: () => '/api/Client/GetAllWithoutDetails',
      providesTags: ['AllClientsWithoutDetails']
    })
  }),
  tagTypes: ['Clients', 'AllClientsWithoutDetails']
})

export const { useGetClientsQuery, useGetAllClientsWithoutDetailsQuery } = clientApi
